import React from 'react';
import styled from 'styled-components';
import { H2, P1 } from '../../styles/textTags';
import { BREAKPOINTS, COLORS } from '../../styles/variables';

const Footer = () => (
  <FooterWr>
    <Content>
      <H2>
        Проект Музейного агентства «Культурная гастрономия» посвящен нематериальному культурному
        наследию Ленинградской области.
      </H2>
      <P1>
        Яркие уникальные гастрономические программы созданы для музеев «Копорская крепость»,
        «Дом станционного смотрителя», Музея истории города Шлиссельбурга, Сланцевского
        историко-краеведческого музея.
      </P1>
      <P1>
        Проект реализован победителем конкурса «Креативный музей» благотворительной программы «Музей
        без границ» Благотворительного фонда Владимира Потанина.
      </P1>
    </Content>
    <Logo src='/imgs/footerLogo.png' alt='Музейное Агентство' />
  </FooterWr>
);

const FooterWr = styled.footer`
  position: relative;

  z-index: 222;
  color: ${COLORS.black};
  padding: 85px 100px;
  background-color: ${COLORS.green};

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 163px;

  @media ${BREAKPOINTS.laptop} {
    padding: 6.07vw 7.14vw;
    gap: 11.64vw;
  }

  @media ${BREAKPOINTS.mobile} {
    padding: 6.67vw 8.75vw;
    gap: 5.83vw;
    flex-direction: column;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${H2} {
    width: 612px;
    text-align: left;
  }
  ${P1} {
    width: 568px;
    line-height: 21px;
  }

  @media ${BREAKPOINTS.laptop} {
    gap: 1.43vw;
    ${H2} {
      width: 43.71vw;
    }
    ${P1} {
      width: 40.57vw;
      line-height: 1.46vw;
    }
  }

  @media ${BREAKPOINTS.mobile} {
    gap: 2.5vw;
    ${H2} {
      width: 100%;
    }
    ${P1} {
      width: 100%;
      line-height: 3.91vw;
    }
  }
`;

const Logo = styled.img`
  width: 295px;
  height: 295px;

  margin-right: 80px;

  @media ${BREAKPOINTS.laptop} {
    width: 21.07vw;
    height: 21.07vw;
  }

  @media ${BREAKPOINTS.mobile} {
    width: 36.88vw;
    height: 36.88vw;
    margin-right: 0;
  }
`;

export default Footer;
